import Popover from "bootstrap/js/dist/popover";

document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll('[data-bs-toggle="popover"]').forEach(el => {

    const selector = el.getAttribute('data-bs-content');
    const template = document.querySelector(selector);

    const items = document.querySelectorAll('.tab-global__item');
    let tabGlobalWidth = 0;
    items.forEach(item => {
      tabGlobalWidth += item.offsetWidth;
    });

    document.documentElement.style.setProperty(
      "--tab-global-width",
      `${tabGlobalWidth}px`
    );

    new Popover(el, {
      customClass: 'bis-popover',
      html: true,
      sanitize: false,
      placement: 'bottom',
      trigger: 'focus',
      content: template ? template.innerHTML : '',
      fallbackPlacements: [],
      popperConfig(defaultBsPopperConfig) {
        return {
          ...defaultBsPopperConfig,
          modifiers: [
            ...defaultBsPopperConfig.modifiers,
            {
              name: 'flip',
              options: {
                fallbackPlacements: []
              }
            }
          ]
        };
      }
    });
  });

});
